/* ==========================================================================
   Future Ecom — sticky header
   CLAUDE.md §Design direction, chrisducker.com: "Centred nav — Logo centred,
   nav items split either side. Sticky, goes solid on scroll."

   Three jobs:
     1. flip the header to its solid state once the hero is behind it
     2. run the mobile menu (focus trap, Escape, scroll lock)
     3. mark the section currently in view with aria-current
   ========================================================================== */

(function () {
  var header = document.querySelector('[data-fe-header]');
  if (!header) return;

  var toggle = header.querySelector('[data-fe-menu-toggle]');
  var menu = document.getElementById('fe-menu');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* 1. Condense on scroll -------------------------------------------------- */

  var condenseAfter = parseInt(header.dataset.condenseAfter || '80', 10);
  var isCondensed = null;

  // No requestAnimationFrame throttle here on purpose: the handler does one
  // attribute write and reads no layout, so it is already cheap, and rAF is
  // paused in background tabs — which made this silently dead under automation.
  function updateCondensed() {
    var next = window.scrollY > condenseAfter;
    if (next === isCondensed) return;
    isCondensed = next;
    header.dataset.condensed = next ? 'true' : 'false';
  }

  window.addEventListener('scroll', updateCondensed, { passive: true });
  updateCondensed();

  /* 2. Mobile menu -------------------------------------------------------- */

  var lastFocused = null;

  function focusable() {
    return Array.prototype.slice.call(
      menu.querySelectorAll('a[href], button:not([disabled])')
    );
  }

  function openMenu() {
    lastFocused = document.activeElement;
    menu.hidden = false;
    // Force a reflow so the browser registers the pre-transition state, then
    // flip. requestAnimationFrame would be tidier but it is paused in
    // background tabs, which leaves the menu open at opacity 0.
    void menu.offsetWidth;
    menu.dataset.open = 'true';
    toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var first = focusable()[0];
    if (first) first.focus();
  }

  function closeMenu() {
    menu.dataset.open = 'false';
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';

    var finish = function () {
      menu.hidden = true;
    };
    if (reduce.matches) finish();
    else window.setTimeout(finish, 250);

    // Back to the control that opened it — that is where a keyboard user
    // expects to land, and lastFocused can be <body> if the menu was opened
    // programmatically.
    (toggle || lastFocused || document.body).focus();
  }

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') closeMenu();
      else openMenu();
    });

    // any anchor tap closes the menu — it's a one-pager, every link scrolls
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a[href]')) closeMenu();
    });

    document.addEventListener('keydown', function (event) {
      if (menu.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu();
        return;
      }

      if (event.key !== 'Tab') return;

      // trap focus inside the open menu
      var items = focusable();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    // a resize up to desktop should never leave the overlay stranded open
    window.addEventListener('resize', function () {
      if (!menu.hidden && window.innerWidth >= 990) closeMenu();
    });
  }

  /* 3. Mark the section in view ------------------------------------------- */

  var links = Array.prototype.slice.call(
    document.querySelectorAll('[data-fe-nav-link]')
  );
  if (!links.length || !('IntersectionObserver' in window)) return;

  var targets = links
    .map(function (link) {
      var id = (link.getAttribute('href') || '').replace('#', '');
      return id ? document.getElementById(id) : null;
    })
    .filter(Boolean);

  if (!targets.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (link) {
          var match = link.getAttribute('href') === '#' + entry.target.id;
          if (match) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      });
    },
    // only counts as "current" once the section owns the middle of the screen
    { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
  );

  targets.forEach(function (target) {
    observer.observe(target);
  });
})();
